<div class="dl-absolute-fill-in-overflow">
  <div class="d-flex justify-content-center dl-landing-container">
    <div class="d-flex column justify-content-center">
      <mat-card class="dl-landing-card p-5 mat-elevation-z8">
        <div class="mb-4">
          <img class="dl-strykerlogo" src="assets/stryker-logo.jpg" alt="Stryker Logo" />
        </div>
        <div class="dl-page-title mb-3">
          Welcome to DataLab!
        </div>
        <div class="mb-3">
          Review the Terms of Use below and then use your corporate account to log in.
        </div>
        <div class="dl-form-block-title-primary">
          Terms of Use
        </div>
        <div class="dl-scrollable-container">
          <app-terms-of-use-text></app-terms-of-use-text>
        </div>
        <mat-card-actions>
          <div *ngIf="!(loggedIn$ | async)">
            <div class="d-flex align-items-center justify-content-end mr-4 mt-3">
              <button class="btn dl-btn dl-btn-primary" (click)="login()">I agree</button>
            </div>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>